<template>
  <main class="course-success-page">
    <AppNavBar
      :title="t('card.purchaseSuccessTitle')"
      background-color="#fff"
      fallback-to="/home/card"
    />

    <div class="course-success__body">
      <app-image class="course-success__image" :src="successImage" alt="" />
      <div class="course-success__amount">-{{ CARD_PRICE }} USDT</div>
      <div class="course-success__status">{{ t("card.purchaseSuccessful") }}</div>
      <p class="course-success__desc">{{ t("card.purchaseSuccessDesc") }}</p>

      <section class="success-card">
        <app-image :src="promoteIcon" alt="" />
        <div>
          <strong>{{ t("card.promotionActivated") }}</strong>
          <p>{{ t("card.promotionActivatedDesc") }}</p>
        </div>
        <span class="success-card__tag">{{ t("card.goPromote") }}</span>
      </section>

      <section class="success-card">
        <app-image :src="cardIcon" alt="" />
        <div>
          <strong>{{ t("card.cardSecured") }}</strong>
          <p>{{ t("card.cardSecuredDesc") }}</p>
        </div>
        <span class="success-card__tag">{{ t("card.pendingOpen") }}</span>
      </section>
    </div>

    <footer class="course-success__footer">
      <van-button round block class="course-success__done" @click="goCardEntrance">
        {{ t("card.done") }}
      </van-button>
      <van-button round block type="primary" @click="goInvite">
        {{ t("card.directPromotion") }}
      </van-button>
    </footer>
  </main>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { navigateWithState } from "@/utils/route-state";
import successImage from "@/assets/images/classImage/img7.png";
import promoteIcon from "@/assets/images/classImage/img8.png";
import cardIcon from "@/assets/images/classImage/img9.png";

const CARD_PRICE = 298;
const { t } = useI18n();
const router = useRouter();

function goCardEntrance() {
  router.replace("/home/card");
}

function goInvite() {
  navigateWithState(router, "/wallet/invite", {
    namespace: "wallet-invite",
    replace: true,
    payload: {
      backTo: "/home/mine",
    },
  });
}
</script>

<style scoped lang="scss">
.course-success-page {
  display: flex;
  height: var(--app-viewport-height);
  min-height: var(--app-viewport-height);
  flex-direction: column;
  overflow: hidden;
  background: #fff;
}

.course-success__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 28px 15px calc(140px + env(safe-area-inset-bottom));
  background: #fff;
  text-align: center;
}

.course-success__image {
  display: block;
  width: 132px;
  height: 132px;
  margin: 0 auto;
}

.course-success__amount {
  margin-top: 4px;
  color: #111;
  font-size: 22px;
  font-weight: 700;
}

.course-success__status {
  display: block;
  width: fit-content;
  margin: 12px auto;
  padding: 4px 10px;
  border-radius: 4px;
  background: rgba(52, 191, 105, 0.12);
  color: #07b077;
  font-size: 14px;
}

.course-success__desc {
  margin: 0 0 24px;
  color: #666;
  font-size: 16px;
  font-weight: 500;
}

.success-card {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  padding: 14px 12px;
  border-radius: 16px;
  background: var(--wp-color-card-3, #f7f3ff);
  text-align: left;

  .app-image {
    flex: 0 0 auto;
    align-self: center;
    width: 42px;
    height: 42px;
  }

  > div {
    display: flex;
    flex: 1;
    min-width: 0;
    flex-direction: column;
    justify-content: center;
  }

  strong {
    color: #222;
    font-size: 14px;
  }

  p {
    margin: 4px 0 0;
    color: #747b88;
    font-size: 11px;
    line-height: 16px;
  }

  .success-card__tag {
    flex: 0 0 auto;
    padding: 6px 10px;
    border-radius: 30px;
    background: var(--wp-color-card-1, #f1eaff);
    color: var(--wp-color-brand-1);
    font-size: 11px;
  }
}

.course-success__footer {
  position: fixed;
  z-index: 20;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 10px 15px calc(10px + env(safe-area-inset-bottom));
  background: #fff;

  .van-button + .van-button {
    margin-top: 10px;
  }

  :deep(.van-button--primary) {
    border-color: var(--wp-color-theme);
    background: var(--wp-color-theme);
  }
}

.course-success__done {
  border-color: var(--wp-color-button-2);
  background: var(--wp-color-button-2);
  color: var(--wp-color-theme);
}
</style>
